<template>
  <div class="mt-3">
    <router-link
      v-show="previousUrl"
      :to="previousUrl"
      tag="button"
      class="btn btn-default mr-1">Previous</router-link>
    
    <button
      v-show="nextUrl"
      class="btn btn-primary mr-1"
      @click.prevent="save">Next</button>

    <button
      v-show="isNotProduction"
      class="btn btn-primary"
      @click.prevent="print">Print</button>
  </div>

</template>

<script>
export default {
  props: {
    previousUrl: {
      type: String,
      default: ""
    },
    nextUrl: {
      type: String,
      default: ""
    },
    v: {
      type: Object,
      default: () => null
    },
    page: {
      type: Object,
      default: () => null
    }
  },
  methods: {
    print() {
      this.v.$touch();
      if (!this.v.$error) {
        this.$store.commit(`${this.page.name}/updateForm`, this.page.form);
        this.$router.push("print");
      }
    },
    save() {
      this.v.$touch();
      this.$nextTick(() => this.focusFirstStatus(this.page));
      if (!this.v.$error) {
        this.$store.commit(`${this.page.name}/updateForm`, this.page.form);
        this.$router.push(this.nextUrl);
      } else {
        this.$snotify.error(
          "Please correct all errors in red.",
          "Validation Error(s)"
        );
      }
    },
    focusFirstStatus(component) {
      if (!component.isValid) {
        //component.$el.focus();
        component.$el.scrollIntoView({ behavior: "smooth", block: "start" });
        var pos = component.$el.style.position;
        var top = component.$el.style.top;
        component.$el.style.position = "relative";
        component.$el.style.top = "-100px";
        component.$el.scrollIntoView({ behavior: "smooth", block: "start" });
        component.$el.style.top = top;
        component.$el.style.position = pos;
        return true;
      }

      let focused = false;

      component.$children.some(childComponent => {
        focused = this.focusFirstStatus(childComponent);
        return focused;
      });

      return focused;
    }
  },
  computed: {
    isNotProduction() {
      return process.env.NODE_ENV !== "production";
    }
  }
};
</script>

<style>
</style>
